<template>
  <div class="bj-section">
    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: "ordercontainer",
  data() {
    return {
      navList: [
        {
          active: true,
          value: "domain-order",
          label: "域名订单",
        },
      ],
    };
  },
  methods: {
    onClick(val) {
      this.$router.push(val);
    },
  },
};
</script>

